var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFeatures = function SvgIconFeatures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_91937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_91937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 23.3002L8.6502 20.0002H4.0002V15.3502L0.700195 12.0002L4.0002 8.6502V4.0002H8.6502L12.0002 0.700195L15.3502 4.0002H20.0002V8.6502L23.3002 12.0002L20.0002 15.3502V20.0002H15.3502L12.0002 23.3002ZM9.0752 16.2502L12.0002 14.4752L14.9252 16.2502L14.1502 12.9252L16.7502 10.6752L13.3252 10.4002L12.0002 7.2502L10.6752 10.4002L7.2502 10.6752L9.8502 12.9252L9.0752 16.2502Z",
    fill: "#05072C"
  }))));
};
export default SvgIconFeatures;